<div class="container-fluid px-0 h-100">
  <si-pwa-install-banner></si-pwa-install-banner>
  <si-loader></si-loader>
  <si-unsaved-changes-dialog></si-unsaved-changes-dialog>
  <router-outlet></router-outlet>
</div>
